import store from '@/store/index'

const storeId = function () {
  if (!store) return

  return store.getters['Me/storeName']
}

export default storeId
